import {BaseCachedService} from './Core/BaseCachedService';

class ConservationActionPhaseService extends BaseCachedService {
    get Url() { return super.Url + "/conservationActionPhases"; }
    get ModelName() { return "Conservation Action Phase"; }
    get PrimaryKeyProperty() { return "conservationActionPhaseId"; }
}

export const service = new ConservationActionPhaseService();

